import { render, staticRenderFns } from "./flag-pt.vue?vue&type=template&id=3829c676"
import script from "./flag-pt.vue?vue&type=script&lang=js"
export * from "./flag-pt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports